module.exports = [{"id":"en-GB","name":"English"},{"id":"it-IT","name":"Italiano"},{"id":"es-ES","name":"Español"},{"id":"fr-FR","name":"Français"},{"id":"de-DE","name":"Deutsch"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/languages.json
// module id = 805
// module chunks = 0